module.exports = __webpack_public_path__ + "b4454edaf991d1703c33cbd32be1d626.svg";